<div class="relative w-full h-full bg-gray-50 rounded-lg overflow-hidden">
  <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
    <!-- Background -->
    <rect width="400" height="400" fill="white"/>

    <!-- Quadrant borders -->
    <rect x="40" y="40" width="160" height="160" fill="none" stroke="#E5E7EB" stroke-width="1"/>
    <rect x="200" y="40" width="160" height="160" fill="none" stroke="#E5E7EB" stroke-width="1"/>
    <rect x="40" y="200" width="160" height="160" fill="none" stroke="#E5E7EB" stroke-width="1"/>
    <rect x="200" y="200" width="160" height="160" fill="none" stroke="#E5E7EB" stroke-width="1"/>

    <!-- Colored rectangle from quadrant origin to point -->
    <rect
      [attr.x]="rectX"
      [attr.y]="rectY"
      [attr.width]="rectWidth"
      [attr.height]="rectHeight"
      [attr.fill]="getQuadrantColor(personalityType)"
      opacity="0.3"
    />

    <!-- Dashed border around colored rectangle -->
    <rect
      [attr.x]="rectX"
      [attr.y]="rectY"
      [attr.width]="rectWidth"
      [attr.height]="rectHeight"
      fill="none"
      [attr.stroke]="getQuadrantColor(personalityType)"
      stroke-width="2"
      stroke-dasharray="5,5"
      opacity="0.5"
    />

    <!-- Main axes -->
    <line x1="200" y1="20" x2="200" y2="380" stroke="#374151" stroke-width="2"/>
    <line x1="20" y1="200" x2="380" y2="200" stroke="#374151" stroke-width="2"/>

    <!-- Arrow heads -->
    <polygon points="200,20 195,30 205,30" fill="#374151"/>
    <polygon points="380,200 370,195 370,205" fill="#374151"/>

    <!-- Axis labels -->
    <text x="398" y="205" font-size="14" text-anchor="end" fill="#374151" font-weight="600">E+</text>
    <text x="195" y="15" font-size="14" text-anchor="end" fill="#374151" font-weight="600">C+</text>

    <!-- Quadrant labels -->
    <text x="120" y="120" font-size="14" text-anchor="middle" fill="#374151" font-weight="500">Popular</text>
    <text x="280" y="120" font-size="14" text-anchor="middle" fill="#374151" font-weight="500">Performer</text>
    <text x="120" y="280" font-size="14" text-anchor="middle" fill="#374151" font-weight="500">Procrastinator</text>
    <text x="280" y="280" font-size="14" text-anchor="middle" fill="#374151" font-weight="500">Pusher</text>

    <!-- Data point with animation -->
    <g>
      <!-- Simple dot -->
      <circle
        [attr.cx]="pointX"
        [attr.cy]="pointY"
        r="0"
        fill="#3B82F6"
      >
        <animate attributeName="r" from="0" to="6" dur="0.3s" fill="freeze"/>
      </circle>
    </g>

    <!-- Coordinate label with background -->
    <g [attr.transform]="'translate(' + pointX + ',' + (pointY - 20) + ')'">
      <rect x="-30" y="-10" width="60" height="20" rx="10" fill="white" stroke="#3B82F6" stroke-width="1.5"/>
      <text x="0" y="4" font-size="11" text-anchor="middle" fill="#1E40AF" font-weight="600">
        ({{ Math.round(xValue) }}, {{ Math.round(yValue) }})
      </text>
    </g>

    <!-- Legend at bottom -->
    <text x="200" y="395" font-size="11" text-anchor="middle" fill="#6B7280">
      E+ : Need to conquer | C+ : Empathic concern
    </text>
  </svg>
</div>
